import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { SideBarComponent } from '../../../components/side-bar/side-bar.component';
import { HeaderComponent } from "../../../components/header/header.component";
import { FooterComponent } from "../../../components/footer/footer.component";


@Component({
  selector: 'app-privacy-policy',
    standalone: true,
  imports: [CommonModule, SideBarComponent, HeaderComponent, FooterComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  /**
   * Logged-in users must see the dashboard sidebar (their account menu),
   * not the guest "Create Account / Sign In" landing sidebar.
   */
  get sidebarMode(): 'dashboard' | 'landing' {
    return isPlatformBrowser(this.platformId) && !!localStorage.getItem('token')
      ? 'dashboard'
      : 'landing';
  }

  scrollToSection(n: number): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const el = document.getElementById('section-' + n);
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

}
